// extracted by mini-css-extract-plugin
export default {"root":"style_root__5yb2w","data":"style_data__rv9Qk","address":"style_address__sCIyP","submit":"style_submit__ftH7x"};